import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { Button } from './ui/button';
import { publicApiCall } from '../utils/api';
import { useToast } from '../hooks/use-toast';

export const WsafeSignInButton = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { publicApiCall('/api/wsafe-si/public-config').then(setCfg).catch(() => {}); }, []);
  if (!cfg?.sign_in_enabled) return null;
  const go = () => {
    const redirect = `${window.location.origin}/auth/wsafe-callback`;
    const sep = cfg.login_url.includes('?') ? '&' : '?';
    window.location.href = `${cfg.login_url}${sep}redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <Button type="button" variant="outline" onClick={go} data-testid="wsafe-si-login-btn"
      className="w-full h-12 mb-3 border-gray-300 hover:bg-gray-50 font-medium rounded-xl">
      <ShieldCheck className="w-5 h-5 mr-2 text-[#17475F]" /> Sign in with WSafe.SI
    </Button>
  );
};

export const WsafeAuthCallback = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace('#', '') || window.location.search);
    const idToken = params.get('id_token') || params.get('token');
    if (!idToken) {
      toast({ title: 'Sign-in failed', description: 'No WSafe.SI token was returned.', variant: 'destructive' });
      navigate('/login');
      return;
    }
    publicApiCall('/api/auth/wsafe-si', { method: 'POST', body: { id_token: idToken } })
      .then((data) => {
        localStorage.setItem('auth_token', data.token);
        localStorage.setItem('user_data', JSON.stringify(data.user));
        window.location.href = '/dashboard';
      })
      .catch((e) => {
        toast({ title: 'Sign-in failed', description: e.message, variant: 'destructive' });
        navigate('/login');
      });
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="wsafe-auth-callback">
      <p className="text-slate-600">Completing WSafe.SI sign-in...</p>
    </div>
  );
};
